import client, { requestConfig } from "./client";

const endpoint = "/api/event-extras";

const get = () => client.get(endpoint, {}, requestConfig());

export default {
  get,
};
